module.exports = __webpack_public_path__ + "img/toeic2.be008c93.png";